import styled from "styled-components";
import {
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_REGULAR,
	COLOR_TEXT_PRIMARY_B2C,
	FONT_WT_LIGHT,
	COLOR_LIGHT_GREY,
	COLOR_HYPERLINK_HOVER,
} from "@website-builder/utilities-index";

export const ContactInfoWrapper = styled.div`
	.smoothWhiteTwistedBackground {
		background-image: linear-gradient(181deg, white, ${COLOR_LIGHT_GREY});
	}
	.boldFont {
		font-weight: ${FONT_WT_MEDIUM};
	}
	span {
		text-align: center;
	}
	position: relative;
	.firstSection {
		display: flex;
		position: relative;
		top: -50px;
		background-color: white;
		width: 60%;
		margin: auto;
		max-width: 1000px;
		flex-direction: column;
		padding: 67px 30px 90px 30px;
		.primaryButton {
			display: block;
			width: 80%;
			margin: auto;
			margin-top: 40px;
			max-width: 300px;
			font-weight: ${FONT_WT_REGULAR};
		}
		@media only screen and (min-width: ${540 + 1}px) and (max-width: ${1024 -
			1}px) {
			width: 90%;
		}
		@media only screen and (max-width: ${540}px) {
			width: 90%;
			padding-top: 0;
		}
	}
	.communicationChannelsContainer {
		display: flex;
		justify-content: space-between;
		align-content: center;
		@media only screen and (max-width: ${540}px) {
			flex-direction: column;
			.communicationChannel {
				margin-top: 40px;
				.title {
					padding-top: 10px;
				}
			}
		}
	}
	.communicationChannel {
		align-items: center;
		display: flex;
		flex: 1;
		justify-content: flex-start;
		flex-direction: column;
		.title {
			font-size: 18px;
			padding-top: 30px;
			padding-bottom: 10px;
		}
		.text {
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			padding-top: 8px;
			display: flex;
			flex-direction: column;
			b,
			strong {
				font-size: 13px;
				font-weight: ${FONT_WT_MEDIUM};
			}
		}
		img {
			width: 50px;
			height: 50px;
			object-fit: contain;
		}
	}
	.springboardFolks {
		position: absolute;
		display: flex;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 50%);
		div {
			margin-right: 12px;
			img {
				width: 86px;
				border-radius: 50%;
				box-shadow: 6px 6px 40px 0 #cab9b9;
			}
		}
		@media only screen and (min-width: ${540 + 1}px) and (max-width: ${1024 -
			1}px) {
			div {
				width: 57px;
				border-radius: 50%;
			}
		}
		@media only screen and (max-width: ${540}px) {
			div {
				width: 57px;
				border-radius: 50%;
			}
		}
	}
	.socialLinksContainer {
		display: flex;
		width: 85%;
		max-width: 1000px;
		margin: auto;
		justify-content: space-between;
		padding-top: 100px;
		padding-bottom: 70px;
		align-items: center;
		.socialLinks {
			display: flex;
			flex: 1;
			img {
				padding: 5px;
			}
		}
		.socialLink {
			padding-right: 50px;
			.heavyWeight {
				font-weight: 500;
				vertical-align: top;
			}
		}
		.owlContainer {
			width: 100px;
			img {
				width: 100px;
			}
			position: relative;
			.messageBubble {
				padding-top: 15px;
				padding-left: 15px;
				font-size: 20px;
				position: absolute;
				background: url("https://res.cloudinary.com/springboard-images/image/upload/homepage-assets/contact-us/speech-bubble.png")
					no-repeat center center;
				background-size: contain;
				height: 80px;
				width: 250px;
				top: -45%;
				transform: translateX(-100%);
				left: 0;
			}
		}
		@media only screen and (min-width: ${540 + 1}px) and (max-width: ${1024 -
			1}px) {
			width: 95%;
			flex-direction: column-reverse;
			.owlContainer {
				width: 80px;
				img {
					width: 80px;
				}
				align-self: flex-end;
				.messageBubble {
					top: -54%;
				}
			}
			.socialLink {
				padding-right: 20px;
				font-weight: 500;
			}
		}
		@media only screen and (max-width: ${540}px) {
			flex-direction: column-reverse;
			width: 90%;

			.socialLinks {
				flex-direction: column;
			}
			.socialLink {
				padding-right: 0;
			}
			.owlContainer {
				width: 60px;
				img {
					width: 60px;
				}
				position: relative;
				left: 30%;
				.messageBubble {
					top: -122%;
					width: 200px;
					padding-left: 15px;
					padding-top: 15px;
				}
			}
		}
	}

	.socialImage {
		max-width: 25px;
		img {
			max-width: 25px;
		}
	}
	p {
		line-height: 27px;
		font-weight: ${FONT_WT_LIGHT};
		margin: 0 0 10px;
	}
	div {
		line-height: 27px;
		text-align: left;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	a {
		text-decoration: underline;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		transition:
			underline 200ms ease-out,
			color 200ms ease-out;
		&:hover {
			text-decoration: none;
			color: ${COLOR_HYPERLINK_HOVER};
		}
	}

	h2 {
		font-size: 30px;
	}

	p,
	h3,
	h2,
	span {
		text-align: center;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	h2,
	h3 {
		font-weight: ${FONT_WT_MEDIUM};
	}
	.no-text-decoration {
		text-decoration: none;
		&:hover,
		&:focus,
		&:visited {
			text-decoration: none;
		}
	}
`;
